import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DraggableComponent } from './draggable.component';
import { FormsModule } from '@angular/forms';
import { BaselayersModule } from './baselayers/baselayers.module';
import { LayercontrolModule } from './layercontrol/layercontrol.module';
import { LegendModule } from './legend/legend.module';
import { DrawtoolModule } from './drawtool/drawtool.module';
import { MeasurementModule } from './measurement/measurement.module';

@NgModule({
  declarations: [DraggableComponent],
  imports: [
    CommonModule,
    FormsModule,
    BaselayersModule,
    LayercontrolModule,
    LegendModule,
    DrawtoolModule,
    MeasurementModule,
  ],
  exports:[DraggableComponent,
    BaselayersModule,
    LayercontrolModule,
    LegendModule,
    MeasurementModule,
    DrawtoolModule,],
})
export class DraggableModule { }
